@if (totalItems > 0) {
  <div class="table-pagination">
    <div class="pagination-info">
      Showing {{ showingFrom }} to {{ showingTo }} of {{ totalItems }} {{ itemLabel }}
    </div>
    <div class="pagination-controls">
      <button type="button" class="btn btn-secondary" (click)="previousPage()" [disabled]="currentPage === 1">
        Previous
      </button>
      @for (page of pageNumbers; track page) {
        @if (page === null) {
          <span class="pagination-ellipsis">…</span>
        }
        @if (page !== null) {
          <button
            type="button"
            class="btn"
            [class.btn-primary]="page === currentPage"
            [class.btn-secondary]="page !== currentPage"
            (click)="goToPage(page)"
            >
            {{ page }}
          </button>
        }
      }
      <button type="button" class="btn btn-secondary" (click)="nextPage()" [disabled]="currentPage === totalPages">
        Next
      </button>
    </div>
  </div>
}